import React from 'react'
import {Navigate} from 'react-router-dom'
import {RUTAS_APLICACION} from '../constantes'
import {useAutorizacion} from './useAutorizacion'

const RutaProtegida = ({modulo, children}) => {
  const {puedeAcceder, autorizacionLista} = useAutorizacion()

  if (!autorizacionLista(modulo)) return null

  return puedeAcceder(modulo) ? (
    children
  ) : (
    <Navigate to={RUTAS_APLICACION.HOME} replace />
  )
}

export default RutaProtegida

